import { useSelector } from 'react-redux'
import './index.css'
import AppRouter from './routes/AppRouter'
import { ThemeProvider } from '@mui/material/styles'
import theme from './theme/theme'
import { Stack, Box } from '@mui/material'
import LanguageSelector from './components/LanguageSelector'
import ContentfulProvider from './contexts/ContentfulProvider'
import TimeoutDialog from './components/TimeoutDialog'
import useBeforeUnload from './hooks/useBeforeUnload'

const App = () => {
  const selectedLanguage = useSelector(({ language }) => language.value)
  useBeforeUnload()

  return (
    <ThemeProvider 
      theme={theme}
    >
      <ContentfulProvider 
        locale={selectedLanguage}
      > 
        <TimeoutDialog />
        <Stack
          sx={{
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
            width: '100%',
            maxWidth: '100vw',
            overflowX: 'hidden',
            minHeight: '100vh',
          }}
        >
          <Stack
            display="grid"
            gridAutoFlow="column"
            gap={2}
            alignItems="center"
            alignContent="center"
            justifyContent="space-between"
            p={2}
          >
            <Stack
              display="inline-grid"
              gap={4}
              gridAutoFlow="column"
              alignItems="center"
            >
              <a
                href="/guiding-our-growth"
              >
                <Box
                  height="45px"
                >
                  <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="logo" />
                </Box>
              </a>
            </Stack>
            <LanguageSelector />
          </Stack>
          <Stack>
            <AppRouter />
          </Stack>
        </Stack>
      </ContentfulProvider>
    </ThemeProvider>
  )
}

export default App